import { useEffect, useMemo, useState } from "react";
import { Badge } from "react-bootstrap";
import { AppLink } from "../../services/goTo.jsx";
import { fetchAlerts } from "../../services/fetchData.js";

/**
 * RoutesList
 * Shows a polished list of current or future routes.
 */
export default function RoutesList({ routes, showFuture }) {
  const [alerts, setAlerts] = useState([]);

  useEffect(() => {
    let isMounted = true;

    async function loadAlerts() {
      try {
        const data = await fetchAlerts();
        if (isMounted) {
          setAlerts(Array.isArray(data) ? data : []);
        }
      } catch (error) {
        if (isMounted) {
          setAlerts([]);
        }
        console.error("Error loading alerts:", error);
      }
    }

    loadAlerts();

    return () => {
      isMounted = false;
    };
  }, []);

  const alertedRoutes = useMemo(() => {
    const routeNames = new Set();

    alerts.forEach((alert) => {
      if (!Array.isArray(alert?.routes)) {
        return;
      }

      alert.routes.forEach((routeName) => {
        routeNames.add(String(routeName).trim());
      });
    });

    return routeNames;
  }, [alerts]);


  if (!routes || routes.length === 0) {
    return (
      <ul className="routes-list">
        <li className="routes-list__empty">No routes to display.</li>
      </ul>
    );
  }

  return (
    <ul className="routes-list">
      {routes.map((route, idx) => {
        const shortName = String(route.route_short_name ?? "").trim();
        const hasAlert = alertedRoutes.has(shortName);

        return (
          <li
            key={`${route.route_id}-${route.route_short_name}-${idx}`}
          >
            <AppLink
              to={`/plan-your-trip/routes/${route.route_short_name}`}
              className="h4 my-0 d-flex align-items-center gap-3 w-full"
            >
              <Badge className="short-name">{route.route_short_name}</Badge>
              <span className="long-name">{route.route_long_name}</span>
              {hasAlert && (
                <i
                  className="fas fa-exclamation-triangle"
                  title="Service alert"
                />
              )}

              {/* ms-auto pushes this element to the far right edge */}
              <span className="icon ms-auto" aria-hidden="true">
                <i className="fas fa-arrow-right fa-2x" />
              </span>
            </AppLink>
          </li>
        );
      })}
    </ul>
  );
}
